/**
 * Absences de chacun (refonte v4 du 18/10/2026) : la demande et « Mes
 * absences ». Sans droit : chacun demande ses propres absences, l'API décide
 * ce qui part en validation.
 */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';

const AbsenceRequestPage = lazy(() => import('./AbsenceRequestPage.js').then((m) => ({ default: m.AbsenceRequestPage })));
const MyAbsencesPage = lazy(() => import('./MyAbsencesPage.js').then((m) => ({ default: m.MyAbsencesPage })));

export const absencesRoutes: AppRoute[] = [
  { path: '/absences/nouvelle', element: <AbsenceRequestPage /> },
  { path: '/profil/absences', element: <MyAbsencesPage /> },
];
